import { emailENUM, TipoContribuyenteRucChoice, TipoFormaPagoEnumChoice } from '@/shared/constants';
import { PaymentMethodEnum, TiposReferidosENUM } from '@/shared/interfaces';
import * as yup from 'yup';
import { validarRestriccionNumeroCelular, validateTelefono } from '..';

interface IRestriccionTelefono {
  tolerancia_repeticion: number,
  no_permitidos: string[],
  longitud_subgrupos: number
}
////*Preventa
export const newPreventaSchema = (
  customRestriccionCelular?: IRestriccionTelefono,
) => yup.object({
  //prospecto: yup.string().required('Campo Obligatorio'),
  //coordenas: yup.string().required('campo obligatorio'),
  direccion: yup.string()
    .min(20, 'La dirección debe tener al menos 20 caracteres')
    .matches(
      /^[^_-]*$/,
      'No se permiten guiones (-) ni guiones bajos (_)'
    )
    .required('Campo Obligatorio'),
  celular_2: yup
    .string()
    .required('Este campo es obligatorio')
    .min(10, 'Número menor a 10 digitos')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"')
    .matches(/^[0-9]+$/, 'Ingresar un número válido')
    .test(
      'no-repetir',
      'Este número ya está siendo utilizado',
      function (value) {
        const otrosNumeros = [
          this.parent.celular,
          this.parent.celular_referencia,
          this.parent.telefono_fijo_referencia,
          this.parent.telefono_adicional,
          this.parent.persona_referencia_celular,
          this.parent.persona_referencia_celular_2,
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),


  email_temporal: yup.string().required()
    .when('servicio_correo', {
      is: (e: string) => e == emailENUM.MANUALMENTE,
      then: schema =>
        schema.matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Ingresar un correo valido').typeError('Campo Obligatorio')
    }).when('servicio_correo', {
      is: (e: string) => e != emailENUM.MANUALMENTE,
      then: schema =>
        schema.required('El campo es obligatorio')
          .test('no-contains-banned-domains', 'Selecciona el dominio del correo en el campo "Servicio de Correo".', (value) => {
            const bannedDomains = ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'icloud.com', 'protonmail.com', 'aol.com', 'zoho.com'];
            return !bannedDomains.some(domain => value?.includes(domain));
          }).typeError('Campo Obligatorio')
    }).typeError('Campo Obligatorio'),
  servicio_correo: yup.string().required('Campo Obligatorio'),
  persona_referencia_nombre: yup.string().required('Campo Obligatorio'),
  persona_referencia_parentesco: yup.string().required('Campo Obligatorio'),
  tipo_contrato: yup.string().required('Campo Obligatorio'),
  tipo_plan: yup.string().required('Campo Obligatorio'),
  tipo_servicio: yup.string().required('Campo Obligatorio'),
  velocidad: yup.string().required('Campo Obligatorio'),
  valor_plan: yup.string().required('Campo Obligatorio'),
  valor_instalacion: yup.string().required('Campo Obligatorio'),
  valor_instalacion_iva: yup.string().required('Campo Obligatorio'),
  valor_instalacion_total: yup.string().required('Campo Obligatorio'),
  provincia: yup.string().required('Campo Obligatorio'),
  ciudad: yup.string().required('Campo Obligatorio'),
  zona: yup.string().required('Campo Obligatorio'),
  sector: yup.string().required('Campo Obligatorio'),
  forma_pago: yup.string().required('Campo Obligatorio'),
  plan: yup.string().required('Campo Obligatorio'),
  tipo_instalacion: yup.string().required('Campo Obligatorio'),

  celular: validarRestriccionNumeroCelular(
    yup
      .string()
      .required('Este campo es obligatorio')
      .min(10, 'Número menor a 10 digitos')
      .matches(/^09\d{8}$/, 'El número debe comenzar con "09"')
      .matches(/^[0-9]+$/, 'Ingresar un número válido')
      .test(
        'no-repetir',
        'Este número ya está siendo utilizado',
        function (value) {
          const otrosNumeros = [
            this.parent.telefono_fijo,
            this.parent.celular_referencia,
            this.parent.telefono_fijo_referencia,
            this.parent.telefono_adicional,
            this.parent.persona_referencia_celular,
            this.parent.persona_referencia_celular_2,
          ].filter(Boolean);

          return !otrosNumeros.includes(value);
        }
      ),
    customRestriccionCelular
  ),
  persona_referencia_celular: yup
    .string()
    .required('Este campo es obligatorio')
    .min(10, 'Número menor a 10 digitos')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"')
    .matches(/^[0-9]+$/, 'Ingresar un número válido')
    .test(
      'no-repetir',
      'Este número ya está siendo utilizado',
      function (value) {
        const otrosNumeros = [
          this.parent.telefono_fijo,
          this.parent.celular_referencia,
          this.parent.telefono_fijo_referencia,
          this.parent.telefono_adicional,
          this.parent.celular
        ].filter(Boolean);

        return !otrosNumeros.includes(value);
      }
    ),
  // persona_referencia_celular_2: (
  //   yup
  //     .string()
  //     .required('Este campo es obligatorio')
  //     .min(9, 'Número menor a 9 digitos')
  //     .test(
  //       'no-repetir',
  //       'Este número ya está siendo utilizado',
  //       function (value) {
  //         const otrosNumeros = [
  //           this.parent.telefono_fijo,
  //           this.parent.celular_referencia,
  //           this.parent.telefono_fijo_referencia,
  //           this.parent.telefono_adicional,
  //           this.parent.celular,
  //           this.parent.persona_referencia_celular,
  //         ].filter(Boolean);
  //         return !otrosNumeros.includes(value);
  //       }
  //     )
  //     .test(
  //       'validar-telefono',
  //       'El número ingresado no es permitido',
  //       function (value) {
  //         const result = validateTelefono(
  //           value,
  //           customRestriccionCelular
  //         );
  //         if (result instanceof yup.ValidationError) {
  //           return this.createError({
  //             message: result.message,
  //           });
  //         }
  //         return true;
  //       }
  //     )
  // ),
  numero_cuenta: yup
    .string()
    .when(['forma_pago', 'tipo_pago_v2'], {
      is: (formaPago: string, tipoPagoV2: string) =>
        formaPago === TipoFormaPagoEnumChoice.DEBITO || tipoPagoV2 === 'DEBITO',
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),

  tipo_cuenta_bancaria: yup
    .string()
    .when(['forma_pago', 'tipo_pago_v2'], {
      is: (formaPago: string, tipoPagoV2: string) =>
        formaPago === TipoFormaPagoEnumChoice.DEBITO || tipoPagoV2 === 'DEBITO',
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),

  tarjeta: yup
    .string()
    .when(['forma_pago', 'tipo_pago_v2'], {
      is: (formaPago: string, tipoPagoV2: string) =>
        formaPago === PaymentMethodEnum.TARJETA && !tipoPagoV2,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional().nullable(),

  tarjeta_fecha_caducidad: yup
    .string()
    .when(['forma_pago', 'tipo_pago_v2'], {
      is: (formaPago: string, tipoPagoV2: string) =>
        formaPago === TipoFormaPagoEnumChoice.TARJETA || tipoPagoV2 === 'CREDITO',
      then: schema =>
        schema
          .required('Campo Obligatorio')
    })
    .optional().nullable(),

  numero_tarjeta: yup
    .string()
    .when(['forma_pago', 'tipo_pago_v2'], {
      is: (formaPago: string, tipoPagoV2: string) =>
        formaPago === TipoFormaPagoEnumChoice.TARJETA || tipoPagoV2 === 'CREDITO',
      then: schema =>
        schema
          .required('Campo Obligatorio')
          .max(24, 'La longitud máxima es 24 caracteres')
          .matches(/^[0-9]+$/, 'Ingresar una cuenta valida'),
    })
    .optional().nullable(),
  cedula_refiere: yup.string().when('tipo_referido', {
    is: (v: string) => v == TiposReferidosENUM.CLIENTE,
    then: schema =>
      schema.required('Campo Obligatorio').typeError('Campo Obligatorio')
  }).optional().nullable(),
  referido_empleado: yup.string().when('tipo_referido', {
    is: (v: string) => v == TiposReferidosENUM.EMPLEADO,
    then: schema =>
      schema.required('Campo Obligatorio').typeError('Campo Obligatorio')
  }).optional().nullable(),

  /* email_referido: yup.string().when('tipo_referido', {
    is: (v: string) => v == TiposReferidosENUM.CLIENTE,
    then: schema =>
      schema.required('Campo Obligatorio').typeError('Campo Obligatorio')
  }).optional(), */

  ruc: yup.string().when('requiere_factura', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').typeError('Campo Obligatorio')
  }).optional(),
  razon_social_factura: yup.string().when('requiere_factura', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').typeError('Campo Obligatorio')
  }).optional(),
  /* numero_cuotas_router_ac: yup.number().when('es_router_ac', {
    is: (v: boolean) => v,
    then: schema =>
      schema
        .required('Campo Obligatorio')
        .moreThan(0, 'El valor debe ser mayor que cero')
        .typeError('Campo Obligatorio')
  }).optional(), */
  numero_cantidad_router_ac: yup.number().when('es_router_ac', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_router_ac: yup.number().when('es_router_ac', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_wifi_6: yup.number().when('requiere_wifi_6', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cantidad_wifi_6: yup.number().when('requiere_wifi_6', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_android_tv: yup.number().when('es_android_tv', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cantidad_android_tv: yup.number().when('es_android_tv', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_ups: yup.number().when('es_ups', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 24').typeError('Campo Obligatorio')
  }).optional(),
  numero_cantidad_ups: yup.number().when('es_ups', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  entidad_financiera: yup
    .string()
    .when(['forma_pago', 'tipo_pago_v2'], {
      is: (formaPago: string, tipoPagoV2: string) =>
        (formaPago === TipoFormaPagoEnumChoice.TARJETA && !tipoPagoV2) ||
        tipoPagoV2 === 'CREDITO' || tipoPagoV2 === 'DEBITO',
      then: schema =>
        schema
          .required('Campo Obligatorio')
    })
    .optional().nullable(),

  representante_legal_tipo_identificacion: yup
    .string()
    .when('tipo_contribuyente', {
      is: (tipo_contribuyente: string) => tipo_contribuyente == TipoContribuyenteRucChoice.SOCIEDAD,
      then: schema =>
        schema
          .required('Campo Obligatorio')
    })
    .optional().nullable(),
  representante_legal_identificacion: yup
    .string()
    .when('tipo_contribuyente', {
      is: (tipo_contribuyente: string) => tipo_contribuyente == TipoContribuyenteRucChoice.SOCIEDAD,
      then: schema =>
        schema
          .required('Campo Obligatorio')
    })
    .optional().nullable(),

  representante_legal_razon_social: yup
    .string()
    .when('tipo_contribuyente', {
      is: (tipo_contribuyente: string) => tipo_contribuyente == TipoContribuyenteRucChoice.SOCIEDAD,
      then: schema =>
        schema
          .required('Campo Obligatorio')
    })
    .optional().nullable(),

  // V2 - 3 niveles de pago
  tipo_pago_v2: yup.string().required('Debe seleccionar el tipo de pago'),
  forma_pago_v2: yup.string().required('Debe seleccionar la forma de pago'),

  codigo_dactilar: yup
    .string()
    .transform((value) => (value === '' ? null : value))
    .nullable()
    .when(['requiere_contrato_fisico', 'pre_requiere_contrato_fisico'], {
      is: (requiere_contrato_fisico: boolean, pre_requiere_contrato_fisico: boolean) =>
        !requiere_contrato_fisico && !pre_requiere_contrato_fisico,
      then: (schema) =>
        schema
          .required('Campo Obligatorio')
          .matches(
            /^[A-Za-z0-9]{10}$/,
            'Debe contener exactamente 10 caracteres alfanuméricos'
          ),
      otherwise: (schema) => schema.optional().nullable(),
    }),
});


export const newPreventaEditVendedorSchema = yup.object({
  id_preventa: yup.string().required('Campo Obligatorio'),
  celular_2: yup.string().required('Campo Obligatorio')
    .min(10, 'El número de contener 10 caracteres')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"'),
  persona_referencia_celular: yup.string().required('Campo Obligatorio')
    .min(10, 'El número de contener 10 caracteres')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"'),
  persona_referencia_celular_2: yup.string().required('Campo Obligatorio')
    .min(10, 'El número de contener 10 caracteres')
    .matches(/^09\d{8}$/, 'El número debe comenzar con "09"'),
});


export const newMotivoPreventaSchema = yup.object({
  id_preventa: yup.string().required('Campo Obligatorio'),
  motivo_rechazo: yup.string().required('Campo Obligatorio'),
});

export const newMotivoPreventaCorporativaSchema = yup.object({
  id_preventa_corporativa: yup.string().required('Campo Obligatorio'),
  motivo_rechazo: yup.string().required('Campo Obligatorio'),
});

export const rejectPreventaSchema = yup.object({
  motivo_rechazo: yup.string().required('El campo motivo rechazo es requerido'),
  observacion_update_cliente: yup
    .string()
    .required('El campo observacion rechazo tecnico es requerido')
    .min(
      10,
      'El campo observacion rechazo tecnico debe tener al menos 10 caracteres'
    )
    .max(
      200,
      'El campo observacion rechazo tecnico no debe exceder los 200 caracteres'
    ),
  estado_preventa: yup
    .string()
    .required('El campo estado orden trabajo es requerido'),
});

